import React, { Suspense, useState, useEffect, useRef } from "react";
import Drawer from 'react-modern-drawer';
import { CommonUtilities } from "../../commonUtils";
import PeriodService from "./PeriodService";
import { format } from 'date-fns';
import cachingMechanisum from "../Common/cachingMechanisum";

export default function PeriodSelection(Param: any) {

    var [openFirst, setOpenFirst] = React.useState(false);
    var [selectedMonth, setSelectedMonth] = React.useState('2030-01-31T00:00:00');
    var [selectedYear, setSelectedYear] = React.useState('2023');
    var [yearList, setYearList] = useState<any[]>([]);
    var [monthList, setMonthList] = useState<any[]>([]);
    var [periodList, setPeriodList] = useState<any[]>([]);
    var userID = CommonUtilities.getAuthAccess().email;
    var currectPeriod = '';

    useEffect(() => {

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        setPeriodList(periodListCache);
        //console.log(periodListCache)
        //console.log(periodListCacheCount)
        yearList = [];

        for (var $i = 0; $i < periodListCache?.length; $i++) {
            if (periodListCache[$i].periodCurrent === 1) {
                // currectPeriod = periodListCache[$i].periodTo;
            }

            if (yearList.length > 0) {
                if (format(new Date(periodListCache[$i].periodTo), 'yyyy') !== format(new Date(yearList[yearList.length - 1].periodTo), 'yyyy')) {
                    yearList.push(periodListCache[$i]);
                }
            } else {
                yearList.push(periodListCache[$i]);
            }
        }

        for (var $i = 0; $i < periodListCache?.length; $i++) {
            if (periodListCache[$i].periodCurrent === 1) {
                currectPeriod = periodListCache[$i].periodTo;
            }
        }


        console.log(currectPeriod)
        console.log(currectPeriod?.length )
        setYearList(yearList);
        if (Param.selectedPeriod === "" && currectPeriod?.length > 8) {
            setSelectedMonth(currectPeriod);
            setSelectedYear(format(new Date(currectPeriod), 'yyyy'));
            updateMonthList(format(new Date(currectPeriod), 'yyyy'));
        } else if (Param?.selectedPeriod?.length > 8){
            setSelectedMonth(Param.selectedPeriod);
            setSelectedYear(format(new Date(Param.selectedPeriod), 'yyyy'));
            updateMonthList(format(new Date(Param.selectedPeriod), 'yyyy'));
        }

    }, []);

    const updateMonthList = (selectedYear: string) => {

        setSelectedYear(selectedYear);

        setMonthList([]);
        monthList = [];
        for (var $i = 0; $i < periodList.length; $i++) {

            if (format(new Date(periodList[$i].periodTo), 'yyyy') === selectedYear) {
                monthList.push(periodList[$i]);
            }
        }
        setMonthList(monthList);
        //setSelectedMonth(monthList[0].periodTo);
    }

    const call_RoyaltyStatements = () => {

        Param.onChange(format(new Date(selectedMonth), 'yyyyMMdd'));
        Param.onChangeDate(selectedMonth);
        setIsOpen(false);
    };

    const keepMonth = (e: any) => {

        var get_selected_year = format(new Date(e), 'yyyy');
        var get_selected_month = selectedMonth.slice(4, 19);
        setSelectedMonth(get_selected_year + get_selected_month)
    }


    const [isOpen, setIsOpen] = React.useState(false)
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }


    return (

        <div>

            <div className="text-right prl pull-left mt pt mt mrs">
                Period
            </div>

            <div className="box width-auto pm ">

                <a className='text-bold turquoise pull-left' onClick={() => { setIsOpen(true); updateMonthList(selectedYear) }}>
                    <i className="icon-angle-right text-m mr pr pl pull-right turquoise" />
                    <i className="icon-vertical-line mt ml pull-right mr grey" />
                    {format(new Date(selectedMonth), 'dd MMMM yyyy')}
                </a>
            </div>
            <Drawer open={isOpen}
                onClose={toggleDrawer}
                direction='right'
                className='react-drawer'
                size={600}>

                <div className="box landing">
                    <div className="box-content">
                        <h1 className="ws-12 m0">Select monthly period</h1>
                        <hr></hr>
                        <div className="ws-12">
                            <div className="ws-12 mtl">
                                <div className="mbl">

                                    <div className="ws-12 pts">
                                        <div className="ws-12 pm pll mbl">
                                            <label className="text-bold pull-left mt mr"> Selected: </label>
                                            <a className="icon-btn edit m0">{format(new Date(selectedMonth), 'dd MMMM yyyy')}</a>

                                        </div>

                                        <div className="ws-6 prl">
                                            <div className="text-bold">
                                                <label className="landing text-center ws-12 pm ml mb bgDark">Month</label>
                                            </div>
                                            <div className="ws-12">
                                                {monthList.map((post: any) => (
                                                    <a className={post.periodTo === selectedMonth ? "ws-12 btn-white text-center ps mb active" : "ws-12 btn-white text-center ps mb"} onClick={() => { setSelectedMonth(post.periodTo); }}>
                                                        {format(new Date(post.periodTo), 'MMMM dd')}
                                                    </a>
                                                ))}

                                            </div>
                                        </div>

                                        <div className="ws-6 pll">
                                            <div className="text-bold">
                                                <label className="landing text-center ws-12 pm ml mb bgDark">Year</label>
                                            </div>
                                            <div className="ws-12">
                                                {yearList.map(post => (
                                                    <a className={format(new Date(post.periodTo), 'yyyy') === selectedYear ? "ws-12 btn-white text-center ps mb active" : "ws-12 btn-white text-center ps mb"} onClick={() => { updateMonthList(format(new Date(post.periodTo), 'yyyy')); keepMonth(post.periodTo); }}>
                                                        {format(new Date(post.periodTo), 'yyyy')}
                                                    </a>
                                                ))}
                                            </div>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="box-footer pull-right pLarge">

                        <button type="submit" className="btn-search pm" onClick={() => call_RoyaltyStatements()}>
                            Update
                        </button>
                    </div>

                </div>

            </Drawer>
        </div>
    )

};
